export const APPROVALS = 'approvals';
export const TESTING = 'testing';
export const RUNNING = 'running';
